import React from 'react';
import {
  $createNodeSelection,
  $createParagraphNode,
  $getNodeByKey,
  $isRootNode,
  $setSelection,
} from 'lexical';
import Html from '../../ui/html/Html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export function HtmlNodeComponent({ nodeKey, html }) {
  const [editor] = useLexicalComposerContext();
  const [isEditing, setIsEditing] = React.useState(true);

  const updateHtml = value => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);
      node.html = value;
    });
  };

  const escapeUp = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);

      if (node !== null && node.getPreviousSibling() === null) {
        const paragraph = $createParagraphNode();
        node.insertBefore(paragraph);

        const nodeSelection = $createNodeSelection();
        nodeSelection.add(paragraph.getKey());
        $setSelection(nodeSelection);
      }
    });
  };

  const escapeDown = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);

      if (node !== null && node.getNextSibling() === null) {
        const paragraph = $createParagraphNode();
        node.insertAfter(paragraph);

        const nodeSelection = $createNodeSelection();
        nodeSelection.add(paragraph.getKey());
        $setSelection(nodeSelection);
      }
    });
  };

  const removeNode = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);

      if ($isRootNode(node)) {
        node.getFirstChild().remove();
      } else {
        node.remove();
      }
    });
  };

  return (
    <Html
      html={html}
      isEditing={isEditing}
      nodeKey={nodeKey}
      updateHtml={updateHtml}
      escapeUp={escapeUp}
      escapeDown={escapeDown}
      removeNode={removeNode}
    />
  );
}
